"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var WeekdayButtonStyle = {
    border: '1px solid #CCC',
    borderRadius: '2px',
    display: 'inline-block',
    textAlign: 'center',
    width: '30px',
    cursor: 'default',
    marginRight: '3px',
    flex: '1 1 30px',
    minWidth: 'unset',
    padding: 'unset'
};
/** TODO: This should ideally come from shared-widgets **/
var WeekDayPicker = /** @class */ (function (_super) {
    __extends(WeekDayPicker, _super);
    function WeekDayPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderWeekDayMapperWidget = function (weekDay) {
            return React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, getContent: function () { return React.createElement(React.Fragment, null, weekDay.weekDayCaption); }, key: weekDay.weekDayId, handleClick: function () { return _this.weekDaysToggleInternal(weekDay.weekDayId); }, selected: _this.isButtonSelected(weekDay.weekDayId), style: WeekdayButtonStyle, testId: weekDay.weekDayCaption, "aria-label": weekDay.weekDayAriaLabel });
        };
        return _this;
    }
    WeekDayPicker.prototype.isButtonSelected = function (weekDayId) {
        return this.props.selectedDayIds && this.props.selectedDayIds.indexOf(weekDayId) >= 0;
    };
    WeekDayPicker.prototype.setDayOfWeek = function (weekDayId) {
        return [weekDayId];
    };
    WeekDayPicker.prototype.toggleDayOfWeek = function (weekDayId) {
        var alreadySelectedIndex = this.props.selectedDayIds.indexOf(weekDayId);
        var isAlreadySelected = alreadySelectedIndex >= 0;
        // If there are multiple days of week selected you can toggle a day off
        if (isAlreadySelected && this.props.selectedDayIds.length > 1) {
            var result = this.props.selectedDayIds.slice();
            result.splice(alreadySelectedIndex, 1); // Delete already selected element
            return result;
        }
        // If selecting an unselected day we just add it to the selected days
        if (!isAlreadySelected) {
            return this.props.selectedDayIds.concat([weekDayId]);
        }
        // If you select the only selected day we do nothing
        return this.props.selectedDayIds;
    };
    WeekDayPicker.prototype.weekDaysToggleInternal = function (weekDayId) {
        var resultSelection = this.props.allowMultipleDaysOfWeek
            ? this.toggleDayOfWeek(weekDayId)
            : this.setDayOfWeek(weekDayId);
        this.props.onSelectionChanged(resultSelection);
    };
    WeekDayPicker.prototype.render = function () {
        return (React.createElement("div", { id: 'week-day-picker', "data-tb-test-id": this.props.testId, style: this.props.style }, this.props.weekDays.map(this.renderWeekDayMapperWidget)));
    };
    return WeekDayPicker;
}(React.Component));
exports.WeekDayPicker = WeekDayPicker;
//# sourceMappingURL=WeekDayPicker.js.map